import { Outlet } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'
import globalContent from '@content/global.json'

export default function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-limestone">
      <Header
        logoText={globalContent.header.logoText}
        nav={globalContent.nav}
        ctaLabel={globalContent.header.ctaLabel}
        ctaHref={globalContent.header.ctaHref}
      />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer
        logoText={globalContent.footer.logoText}
        tagline={globalContent.footer.tagline}
        nav={globalContent.nav}
        email={globalContent.footer.email}
        legalName={globalContent.footer.legalName}
      />
    </div>
  )
}
